// 출퇴근 시간 설정 모달 영역 (Phase 1-2 C)
// AttendanceManagement에서 분리 (300줄 룰)
import React from 'react';
import { TimeSettingsModal } from './TimeSettingsModal';
import { AttendanceTimeSettingsModal } from './AttendanceTimeSettingsModal';

export function TimeSettingsModalsArea({
  ts, companyModalOpen, setCompanyModalOpen, onEditCompany,
  companyCodes, // 2026-04-28: AttendanceTimeSettingsModal 필터 — 자기 회사만 노출 (PINE/DOT/LNJ/통합)
  ipAliases = [],
  timeSettingsPathBuilder,
}) {
  return (
    <>
      <TimeSettingsModal
        open={ts.timeSettingsOpen}
        loading={ts.timeSettingsLoading}
        saving={ts.timeSettingsSaving}
        draftRows={ts.timeSettingsDraftRows}
        policy={ts.timeSettingsPolicy}
        templateWeeklyPreview={ts.templateWeeklyPreview}
        onClose={() => ts.setTimeSettingsOpen(false)}
        onSave={ts.saveTimeSettings}
        onAddRow={ts.addTimeSettingRow}
        onPatchRow={ts.patchTimeSettingRow}
        onPatchRule={ts.patchTimeSettingRule}
        onRemoveRow={ts.removeTimeSettingRow}
        onPolicyChange={(updates) => ts.setTimeSettingsPolicy((prev) => ({ ...prev, ...updates }))}
        workLocationOptions={ipAliases}
      />
      <AttendanceTimeSettingsModal
        open={companyModalOpen}
        onClose={() => setCompanyModalOpen(false)}
        onEditCompany={onEditCompany}
        companyCodes={companyCodes}
        timeSettingsPathBuilder={timeSettingsPathBuilder}
      />
    </>
  );
}
